import React from "react";
import hero from "../assets/img/Industries/cro_main.png";
import doc_sub_1 from "../assets/img/Industries/cro_sub_1.png";
import doc_sub_2 from "../assets/img/Industries/cro_sub_2.png";
import DownloadBrochure from "./DownloadBrochure";
import { Link as RouterLink } from 'react-router-dom';


const CroCdmo = () => {

    return (
        <div className='portifoliobody'>
            <main id="main">
                <section id="pharma" className="about text-start" style={{paddingTop:'40px'}}>
                    <div className="ph-hero">
                        <div className="ph-title carousel-container animate__animated animate__fadeInLeft" data-aos="fade-left" data-aos-delay="100">
                            <div className="ph-title-content">
                                <h1>Advanced Lab Management Software for CROs & CDMOs</h1>
                                <p>Comprehensive ELN, Informatics, and Lab Management Software for Contract Research, Development, and Manufacturing Organizations.</p>
                            </div>
                            <div className="book_a_demo">
                                <RouterLink to='/demo'> 
                                    <button className="book_a_demo_btn">Get a Demo</button>
                                </RouterLink>
                            </div>
                        </div>
                        <div className="ph-hero-img  carousel-container animate__animated animate__fadeInRight" data-aos="fade-right" data-aos-delay="100">
                            <img src={hero} alt="pharma lab" />
                        </div>
                    </div>

                    <div className="section-container" style={{marginTop:'0'}}>
                        <div className="row">
                            <div className="section-pro">
                                <div className="sec-out">
                                    <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100" style={{justifyContent:'center', alignContent:'center'}}>
                                        <img src={doc_sub_1} alt="pharma lab"/>
                                    </div>  
                                    <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                        <div className="sec-title"><h1>Streamlining Lab Operations for CROs & CDMOs</h1></div>
                                        <ul>
                                            <li><b>Unified Digital Lab Environment – </b> Integrate ELN, informatics, and LIMS into a single platform for seamless research, development, and manufacturing workflows.</li>
                                            <li><b>Regulatory Compliance & Data Integrity – </b>Ensure adherence to <b>FDA 21 CFR Part 11, GxP, and ISO</b> standards with electronic signatures, audit trails, and access controls.</li>
                                            <li><b>End-to-End Sample & Inventory Management – </b> Track samples, reagents, and consumables in real time to optimize resource utilization and prevent shortages.</li>
                                            <li><b>Automated Workflow & Process Standardization – </b> Enhance efficiency by automating lab procedures, data capture, and reporting for consistent and repeatable processes.</li>
                                            <li><b>Seamless Collaboration & Data Sharing – </b>Enable real-time communication between research teams, sponsors, and partners with centralized data access and secure cloud deployment.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="sec-out" style={{paddingTop:'2rem'}}>
                                    <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100" style={{justifyContent:'center', alignContent:'center'}}>
                                        <img src={doc_sub_2} alt="pharma lab"/>
                                    </div>  
                                    <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                        <div className="sec-title"><h1>Enhancing Efficiency & Compliance for Contract Services</h1></div>
                                        <ul>
                                            <li><b>Comprehensive Project & Study Management  – </b> Plan, execute, and monitor contract research and development projects with built-in task tracking and milestone management.</li>
                                            <li><b>Scalability & Cloud Accessibility – </b> Support multi-site operations with a scalable, cloud-enabled platform for remote access and global collaboration.</li>
                                            <li><b>Advanced Analytics & Reporting – </b> Generate customizable reports, track key performance indicators, and gain insights for data-driven decision-making.</li>
                                            <li><b>Seamless Instrument & System Integration – </b> Connect effortlessly with analytical instruments, <b>ERP, MES, ELN, and LIMS</b>, ensuring smooth data flow and eliminating manual data entry.</li>
                                            <li><b>Robust Security & IP Protection – </b>  Protect sensitive research data with encryption, role-based access controls, and compliance-driven security protocols.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </main>
            <div data-aos="fade-up" data-aos-delay="100">
                <DownloadBrochure product={'Industries'}/>
            </div>
                
        </div>
    )
}

export default CroCdmo;